import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Button, Table } from 'react-bootstrap';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import ButtonStyle from '../util/ButtonStyle';
import DatePicker from "react-datepicker";
import NumberFormat from 'react-number-format';
import DeleteIcon from '@material-ui/icons/Delete';
import format from 'date-fns/format';
import { useSelector } from 'react-redux';
import moment from 'moment';

const initialState = {
    refundName : '',
    phone1 : '',
    phone2 : '',
    phone3 : '',
    memo : '',
}

const refundMoneyInitial = [{memo : '', amount : 0}]

export default function RefundInfoAdd({match}) {
    const seq = match.params.seq;
    const [refundMoney,setRefundMoney] = useState([]);
    const [addRefundMoney,setAddRefundMoney] = useState(refundMoneyInitial);
    const [refundName, setRefundName] = useState('');
    const [phone1, setPhone1] = useState('');
    const [phone2, setPhone2] = useState('');
    const [phone3, setPhone3] = useState('');
    const [reason, setReason] = useState('');
    const [accountBank, setAccountBank] = useState('');
    const [accountNum, setAccountNum] = useState('');
    const [accountName, setAccountName] = useState('');
    const [useDay, setUseDay] = useState('');
    const [sdate, setSdate] = useState(null);
    const [edate, setEdate] = useState(null);
    const [manager, setManager] = useState('');
    const [step, setStep] = useState('');
    const data = useSelector(state => state.data);


    function handleRadio(event){
        setStep(event.target.value)
    }

    
    let mode = 'server';
    let node_api = 'https://api.smartg.kr:3000'
    if(mode === 'local'){
        node_api = "http://192.168.76.23:3000"
    }

    function getRefundDetailInfo(){
        axios({
            url : node_api + "/refund/get_refund_detail",
            method : "post",
            data : {
                seq : seq
            }
        }).then(function (res){
            let temp = res.data.rows[0];
            setRefundName(res.data.rows[0].refundName);
            let phone1 = res.data.rows[0].refundPhone.substring(0,3);
            let phone2 = res.data.rows[0].refundPhone.substring(3,7);
            let phone3 = res.data.rows[0].refundPhone.substring(7,11);
            setPhone1(phone1);
            setPhone2(phone2);
            setPhone3(phone3);
            setReason(res.data.rows[0].reason)
            setAccountBank(res.data.rows[0].accountBank);
            setAccountNum(res.data.rows[0].accountNum);
            setAccountName(res.data.rows[0].accountName);
            setStep(res.data.rows[0].state);
            setManager(res.data.rows[0].manager);
            setUseDay(res.data.rows[0].use_day);
            setSdate(moment(res.data.rows[0].refund_sdate).toDate());
            setEdate(moment(res.data.rows[0].refund_edate).toDate());
        }).catch(function(error){
            console.log(error);
        })
    }

    function getRefundPriceInfo() {
        axios({
            url : node_api + "/refund/get_refund_price",
            method : "post",
            data : {
                seq : seq
            }
        }).then(function (result){
            setRefundMoney(result.data.rows);
        }).catch(function (error){
            console.log(error);
        })
    }

    function handleRefundMoneyChange(index, e){
        let temp_data = [...refundMoney];
        temp_data[index][e.target.name] = e.target.value;
        setRefundMoney(temp_data);
    }

    function handleAddRefundMoneyChange(e){
        console.log(e.target.value);
        let temp_data = [...addRefundMoney];
        temp_data[0][e.target.name] = e.target.value;
        setAddRefundMoney(temp_data);
    }

    function handleRefundMoneyAdd() {
        axios({
            url : node_api + "/refund/add_refund_price",
            method : "post",
            data : {
                refund_seq : seq,
                memo : addRefundMoney[0].memo,
                amount : addRefundMoney[0].amount
            }
        }).then(function (result){
            if(result.data.ret !== 'Y'){
                alert(result.data.msg);
                return;
            }
            setAddRefundMoney([{memo : '', amount : 0}]);
            calcRefundMoney();
        }).catch(function (error){
            console.log(error);
        })
    }

    function deleteRefundMoney(seq) {
        let answer = window.confirm('환불금액 내역을 삭제하시겠습니끼?')
        if(answer){
            axios({
                url : node_api + "/refund/delete_refund_price",
                method : "post",
                data : {
                    seq : seq
                }
            }).then(function (result){
                calcRefundMoney();
            }).catch(function (error){
                console.log(error);
            })
        }
    }

    function calcRefundMoney(){
        axios({
            url : node_api + "/refund/calc_refund_price",
            method : "post",
            data : {
                refund_seq : seq
            }
        }).then(function (result){
            getRefundPriceInfo();
        }).catch(function (error){
            console.log(error);
        })
    }

    function handleEdit() {
        if(!refundName){
            alert("이름을 입력해 주세요.")
            return false;
        }
        if(!phone1 || !phone2 || !phone3){
            alert("휴대폰 번호를 입력해주세요.")
            return false;
        }
        if(!reason){
            alert("환불사유를 입력해주세요.")
            return false;
        }
        if(!accountBank || !accountNum || !accountName ){
            alert("환불계좌정보를 입력해 주세요.")
            return false;
        }
        if(!manager){
            alert("지점 담당자 이름을 입력해주세요.")
            return false;
        }
        
        let phone = phone1+phone2+phone3;
        let format_sdate = moment(sdate).format('YYYY-MM-DD');
        let format_edate = moment(edate).format('YYYY-MM-DD');
        axios({
            url : node_api + "/refund/edit_refund_price",
            method : "post",
            data : {
                refund_seq : seq,
                data : refundMoney
            }
        }).then(function (result){
            if(result.data.ret != 'Y'){
                alert(result.data.msg);
                return;
            }
            calcRefundMoney();
            axios({
                url : node_api + "/refund/edit_refund",
                method : "post",
                data : {
                    seq : seq,
                    name : refundName,
                    phone : phone,
                    reason : reason,
                    account_bank : accountBank,
                    account_num : accountNum,
                    account_name : accountName,
                    state : step,
                    manager : manager,
                    refund_sdate : format_sdate,
                    refund_edate : format_edate,
                    use_day : useDay,
                }
            }).then(function (response){
                if(response.data.ret !== 'Y'){
                    alert(response.data.msg);
                    return;
                }
                alert("수정이 완료되었습니다.");
                window.location.href = '/refundInfo/'+ seq;
            }).catch(function (error){
                console.log(error);
            })
        }).catch(function (error){
            console.log(error);
        })
    }

    function moveBack() {
        window.history.back();
    }
    
    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            getRefundDetailInfo();
            getRefundPriceInfo();
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3>환불 정보 등록</h3>
            <div className="content-component">
                <div className="content-header">
                </div>
                <div className="content-body refund-info-edit">
                <div className="info-table-left text-left">
                    <h5>환불 신청 기본 정보</h5>
                    <Table bordered className="refund-table">
                        <tbody>
                            <tr>
                                <td>고객명</td>
                                <td>
                                    <input type="text" name="refundName" value={refundName} onChange={(e)=>setRefundName(e.target.value)} className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>휴대전화</td>
                                <td>
                                    <div>
                                        <input type="text" name="phone1" maxLength="3" className="form-control d-inline-block w-25" value={phone1} onChange={(e)=>setPhone1(e.target.value)}/> -&nbsp;
                                        <input type="text" name="phone2" maxLength="4" className="form-control d-inline-block w-25" value={phone2} onChange={(e)=>setPhone2(e.target.value)}/> -&nbsp;
                                        <input type="text" name="phone3" maxLength="4" className="form-control d-inline-block w-25" value={phone3} onChange={(e)=>setPhone3(e.target.value)}/>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>환불사유</td>
                                <td>
                                    <div>
                                    <textarea name="reason" className="form-control" value={reason} onChange={(e)=> setReason(e.target.value)}>
                                    </textarea>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>환불계좌정보</td>
                                <td>
                                <table className="inner-table">
                                    <tbody>
                                        <tr>
                                            <td>은행명</td>
                                            <td>
                                            <input type="text" name="accountBank" value={accountBank} onChange={(e)=> setAccountBank(e.target.value)} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>계좌번호</td>
                                            <td>
                                            <input type="text" name="accountNum" value={accountNum} onChange={(e)=> setAccountNum(e.target.value)} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>소유주</td>
                                            <td>
                                            <input type="text" name="accountName" value={accountName} onChange={(e)=> setAccountName(e.target.value)} className="form-control" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                ※ 환불계좌정보를 정확하게 입력해주세요.
                                </td>
                            </tr>
                            <tr>
                                <td>이용시작일</td>
                                <td>
                                    <DatePicker
                                        selected = {sdate}
                                        onChange={(date)=>setSdate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                        locale="ko"
                                        showYearDropdown
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>이용종료일</td>
                                <td>
                                    <DatePicker
                                        selected = {edate}
                                        onChange={(date)=>setEdate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                        locale="ko"
                                        showYearDropdown
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>이용일</td>
                                <td>
                                    <input type="text" name="useDay" value={useDay} onChange={(e)=>setUseDay(e.target.value)} className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>신청상태</td>
                                <td>
                                <label>
                                <input type="radio" name="radioGroup" value='회원신청' checked={step === "회원신청"} onChange={handleRadio}/>
                                &nbsp;회원신청
                                </label>
                                &nbsp;
                                <label>
                                <input type="radio" name="radioGroup" value='지점승인' checked={step === "지점승인"} onChange={handleRadio}/>
                                &nbsp;지점승인
                                </label>
                                &nbsp;
                                <label>
                                <input type="radio" name="radioGroup" value='본사승인' checked={step === "본사승인"} onChange={handleRadio}/>
                                &nbsp;본사승인
                                </label>
                                </td>
                            </tr>
                            <tr>
                                <td>지점 담당자</td>
                                <td>
                                    <input type="text" name="manager" value={manager} onChange={(e)=>setManager(e.target.value)} className="form-control" />
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                <div className="button-container">
                    <ButtonStyle mode="edit" title="수정" buttonClick={() => handleEdit()}/>
                    <ButtonStyle mode="list" title="뒤로" buttonClick={() => moveBack()}/>
                </div>
                </div>
                <div className="info-table-right">
                    <h5>환불 신청 상세 정보</h5>
                    <Table bordered className="refund-table-detail">
                        <tbody>
                            <tr>
                                <td>항목</td>
                                <td>금액</td>
                                <td style={{width : 80}}>action</td>
                            </tr>
                            {
                                refundMoney.map((item, index) => {
                                    return(
                                        <tr>
                                            <td>
                                                <input type="text" value={item.memo} name="memo" onChange={(e) => handleRefundMoneyChange(index, e)} className="form-control" />
                                            </td>
                                            <td style={{textAlign : 'right'}}>
                                                <input type="text" value={item.amount} name="amount" onChange={(e) => handleRefundMoneyChange(index, e)} className="form-control" />
                                            
                                            </td>
                                            <td style={{textAlign : 'center'}}><DeleteIcon onClick={()=>deleteRefundMoney(item.seq)}/></td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                    <h5>환불 금액 항목 추가</h5>
                    <Table bordered className="refund-table-detail">
                        <tbody>
                            <tr>
                                <td>
                                    <input type="text" name="memo" value={addRefundMoney[0].memo} className="form-control" onChange={(e) => handleAddRefundMoneyChange(e)}/>
                                </td>
                                <td>
                                    <input type="text" name="amount" value={addRefundMoney[0].amount} className="form-control" onChange={(e) => handleAddRefundMoneyChange(e)}/>
                                </td>
                                <td style={{width : 80}}>
                                    <ButtonStyle mode="add" title="추가" buttonClick={() => handleRefundMoneyAdd()}/>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                </div>
            </div>
            </div>
            </div>
        </main>
    )
}